import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { message } from 'antd';
import Loader from '../Loader/Loader';
import dashboardLogo from '../../Images/Group 1171275225@2x.png'
import {MdMonitorHeart, MdOutlineQueryBuilder, MdNotificationsActive, MdNotifications, MdGavel, MdOutlineSubscriptions, MdOutlineContentPaste, MdDashboard, MdOutlineCardGiftcard, MdOutlineFilterAltOff, MdCategory, MdPerson, MdEventAvailable } from 'react-icons/md'
import { TbCirclesRelation } from "react-icons/tb";
import { CgProfile } from "react-icons/cg";
import { BiSupport } from "react-icons/bi";
import { GiCreditsCurrency } from "react-icons/gi";
import { AiTwotoneLayout } from "react-icons/ai";

import { IoMdArrowDroprightCircle, IoMdArrowDropdownCircle } from "react-icons/io";


function SideNav({ isOpen }) {
  const location = useLocation();
  // const [loading, setLoading] = useState(false)
  const [isContentDropdownOpen, setIsContentDropdownOpen] = useState(false)

  const toggleContentDropdown = () => {
    setIsContentDropdownOpen(!isContentDropdownOpen)
  }


  return (
    <>

      <aside
        className={`overflow-y-auto scrollbar-hidden bg-gradient-to-br from-purple-700 to-purple-300 text-white w-64 h-screen p-4 fixed top-0 left-0 transition-transform transform ${isOpen ? 'translate-x-0' : '-translate-x-full'
          } shadow-lg`}
      >

        {/* Logo Section */}
        <div className="flex flex-col items-center mb-10">
          <div className=" flex items-center justify-center shadow-md">
            <img
              className="h-32 w-32"
              src={dashboardLogo}
              alt="Admin Logo"
            />
          </div>
          {/* <h1 className="text-lg font-bold mt-4 text-center">Employee Dating Admin</h1> */}
        </div>


        {/* Navigation Links */}
        <ul className="space-y-6">
          {/* Dashboard Link */}
          <li>
            <Link
              to="/home"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/home' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <MdDashboard className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Dashboard</span>
            </Link>
          </li>

          {/* Profile Link */}
          <li>
            <Link
              to="/profile"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/profile' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <CgProfile className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Profile</span>
            </Link>
          </li>


          {/* User management Link */}
          <li>
            <Link
              to="/user-management"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/user-management' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <MdPerson className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>User Management</span>
            </Link>
          </li>


          {/* Voucher Link */}
          <li>
            <Link
              to="/billing"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/billing' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <GiCreditsCurrency className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Credit Management</span>
            </Link>
          </li>



           {/* Global occasion management Link */}
           <li>
            <Link
              to="/global-occasions"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/global-occasions' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <MdEventAvailable className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Global Occasion</span>
            </Link>
          </li>


          {/* Voucher Link */}
          <li>
            <Link
              to="/occassion"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/occassion' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <MdCategory className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Occasion Category</span>
            </Link>
          </li>

          {/* Voucher Link */}
          <li>
            <Link
              to="/relation"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/relation' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <TbCirclesRelation className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Relation Category</span>
            </Link>
          </li>

         
          <li>
            <Link
              to="/filter"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/filter' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <MdOutlineFilterAltOff className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Filter Category</span>
            </Link>
          </li>

          {/* Voucher Link */}
          <li>
            <Link
              to="/Layout-Category"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/Layout-Category' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <AiTwotoneLayout className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Layout</span>
            </Link>
          </li>


          {/* Voucher Link */}
          <li>
            <Link
              to="/voucher"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/voucher' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <MdOutlineCardGiftcard className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Promise Voucher</span>
            </Link>
          </li>


          <li>
            <Link
              to="/voucher-tracking"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/voucher-tracking' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <MdMonitorHeart className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Voucher Monitoring</span>
            </Link>
          </li>


          <li>
            <Link
              to="/notifications"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/notifications' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <MdNotifications className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>All Notifications</span>
            </Link>
          </li>

          <li>
            <Link
              to="/admin-notifications"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/admin-notifications' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <MdNotificationsActive className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Send Notifications</span>
            </Link>
          </li>


          <li>
            <Link
              to="/query"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/query' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <MdOutlineQueryBuilder className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Query </span>
            </Link>
          </li>

          <li>
            <Link
              to="/terms-conditions"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/terms-conditions' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <MdGavel className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Terms & Conditions</span>
            </Link>
          </li>

          <li>
            <Link
              to="/help-&-support"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/help-&-support' ? 'bg-purple-400' : 'hover:bg-purple-800'
                }`}
            >
              <BiSupport className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Help & Support</span>
            </Link>
          </li>
          

        </ul>


      </aside>
    </>
  )
}

export default SideNav